export default (elementId: string): void => {
    const clickEvent = document.createEvent('HTMLEvents');
    clickEvent.initEvent('click', true, true);
    const target = document.getElementById(elementId);
    target!.dispatchEvent(clickEvent);
};



// WEBPACK FOOTER //
// ./src/view/triggerClickOnExcelDownload.ts